import { Component, Inject, OnInit } from '@angular/core';
import { AirportNavaid, NavaidType } from '../models/airport-navaid.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { LatLon } from '../../util/geodesy/latlon';
import { NavaidService } from '../service/navaid.service';

@Component({
  selector: 'app-edit-navaid',
  templateUrl: './edit-navaid.component.html',
  styleUrls: ['./edit-navaid.component.scss']
})
export class EditNavaidComponent implements OnInit {
  navaid: AirportNavaid;
  origNavaid: AirportNavaid;
  isNew = false;
  isLoading = true;
  airportId: number;
  formGroup: FormGroup;
  latitude: number;
  longitude: number;
  selectedNavaidType: string;

  constructor(private _matDialogRef: MatDialogRef<EditNavaidComponent>,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data,
              private _navaidService: NavaidService) {
    this.navaid = data.navaid || new AirportNavaid();
    this.isNew = data.isNew || false;
    this.airportId = data.airportId;
    this.origNavaid = Object.assign(new AirportNavaid(), data.navaid);
    if (this.navaid.location != null) {
      this.latitude = this.navaid.location.lat;
      this.longitude = this.navaid.location.lon;
    } else {
      this.latitude = null;
      this.longitude = null;
    }
    if (this.isNew) {
      this.selectedNavaidType = '';
    } else {
      this.selectedNavaidType = this.getNavaidType(this.navaid.type);
    }
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      name: new FormControl(this.navaid.name, [Validators.required, Validators.maxLength(100)]),
      identifier: new FormControl(this.navaid.identifier, [Validators.required, Validators.maxLength(6)]),
      type: new FormControl(this.selectedNavaidType, [Validators.required]),
      frequency: new FormControl(this.navaid.frequency, [Validators.required, Validators.pattern('^-?\\d{0,6}\\.?\\d{0,3}$')]),
      latitude: new FormControl(this.latitude, [Validators.required, Validators.pattern('^-?\\d{0,3}\\.?\\d{0,7}$')]),
      longitude: new FormControl(this.longitude, [Validators.required, Validators.pattern('^-?\\d{0,3}\\.?\\d{0,7}$')])
    });
    this.isLoading = false;
  }

  getNavaidType(type: NavaidType): string {
    switch (type) {
      case NavaidType.DME:
        return 'DME';
      case NavaidType.MarineNDB:
        return 'Marine NDB';
      case NavaidType.NDB:
        return 'NDB';
      case NavaidType.NDB_DME:
        return 'NDB_DME';
      case NavaidType.TACAN:
        return 'TACAN';
      case NavaidType.VOR:
        return 'VOR';
      case NavaidType.VOR_DME:
        return 'VOR_DME';
      case NavaidType.VORTAC:
        return 'VORTAC';
      case NavaidType.VOT:
        return 'VOT';
      default:
        return '';
    }
  }

  setNavaidType(type: string): NavaidType {
    switch (type) {
      case 'DME':
        return NavaidType.DME;
      case 'Marine NDB':
        return NavaidType.MarineNDB;
      case 'NDB':
        return NavaidType.NDB;
      case 'NDB_DME':
        return NavaidType.NDB_DME;
      case 'TACAN':
        return NavaidType.TACAN;
      case 'VOR':
        return NavaidType.VOR;
      case 'VOR_DME':
        return NavaidType.VOR_DME;
      case 'VORTAC':
        return NavaidType.VORTAC;
      case 'VOT':
        return NavaidType.VOT;
    }
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let result: any;
      this.navaid.name = this.formGroup.value.name;
      this.navaid.identifier = this.formGroup.value.identifier;
      this.navaid.type = this.setNavaidType(this.formGroup.value.type);
      this.navaid.frequency = this.formGroup.value.frequency;
      this.navaid.location = new LatLon(this.formGroup.value.latitude, this.formGroup.value.longitude);

      if (this.isNew) {
        result = await this._navaidService.postNavaid(this.navaid);
        this.navaid = AirportNavaid.parse({ navaid: result });
      } else {
        result = await this._navaidService.putNavaid(this.navaid);
        this.navaid = AirportNavaid.parse({ navaid: result });
      }
      this.close({cancelBtnClicked: false, success: true, navaid: this.navaid});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false, error: e});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.navaid, this.origNavaid);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }

}
